import { FC } from 'react';

import {
  ClientAccountStatusType,
  ClientOnboardingStatusType,
  ClientVersionEntity,
} from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { useTranslation } from 'libs/i18n';
import {
  renderClientStatus,
  getVersionDate,
} from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import { ClientSections, ClientSectionsProps } from '../components';
import { ClientFormType } from '../forms/clientForm';

export interface ClientVersionViewProps extends ClientSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: ClientVersionEntity[];
  currentOnboardingStatus?: ClientOnboardingStatusType;
  currentAccountStatus?: ClientAccountStatusType | null;
  initialValues?: ClientFormType;
  fullName: string;
  versionId: string;
  snapshotLoading?: boolean;
  hasRepresentative: boolean;
  onChangeVersion: (version: ClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const ClientVersionView: FC<ClientVersionViewProps> = ({
  breadcrumbsTitles,
  versions,
  currentAccountStatus,
  currentOnboardingStatus,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  hasRepresentative,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => {
  const { t } = useTranslation();
  const status = currentAccountStatus || currentOnboardingStatus;
  return (
    <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
      <VersionView
        content={
          initialValues && (
            <Form
              initialReadOnly
              initialShowCopyButton
              initialValues={initialValues}
              onSubmit={() => {}}
            >
              <ClientSections
                hideActivitySection
                countryRiskAt={getVersionDate(versions, versionId)}
                {...sectionsProps}
              />
            </Form>
          )
        }
        loading={snapshotLoading || !initialValues}
        name={fullName}
        topContent={status && renderClientStatus({ status }, t, { size: 's' })}
        versionId={versionId}
        versions={versions}
        onChangeVersion={onChangeVersion}
        onCloseVersionHistory={onCloseVersionHistory}
      />
    </LayoutWithNavigationBreadcrumbs>
  );
};
